export default __webpack_public_path__ + "locales/sq-AL/ChangeUserTypeDialog.json?hash=10aa61c56358da35cf30dbcdcc55bb30";